import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../lib/site";

const SITE = "Appartamenti in Val di Sole";
const ORIGIN = SITE_URL;

export default function Seo({ title, description, path = "", image, jsonLd, noindex = false }) {
  const fullTitle = !title
    ? `${SITE} | Case vacanza e appartamenti in Val di Sole, Trentino`
    : title.includes(SITE) ? title : `${title} | ${SITE}`;
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
